import { Routes } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { initialize, loggedIn, packagesEnabled, learningPortfolioEnabled, hasPermissionGuard, allCoursesEnabled } from '@app/core/guards';
import { videosStoreProviders } from '@app/store/videos';
import { menuAdminRoutes } from './menu-admin/menu-admin.routing';
import { newsStoreProviders } from './store/news';
import { audioStoreProviders } from './store/audio';
import { materialsStoreProviders } from './store/materials';
import { imageBlockStoreProviders } from './store/image-block';
import { textStoreProviders } from './store/text';
import { modalRoutes } from './shared/components/modal/modal.route';
import { profileStatisticsStoreProviders } from './store/profile-statistics';
import { certificatesStoreProviders } from './store/certificates';
import { learningPortfolioStoreProviders } from './store/learning-portfolio';

export const appRoutes: Routes = [
    {
        path: '',
        redirectTo: initialize(),
        pathMatch: 'full',
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routing').then(({ routes }) => routes),
    },
    {
        path: 'storybook',
        loadChildren: () => import('./storybook/storybook.routing').then(({ routes }) => routes),
    },
    {
        path: '',
        canActivate: [loggedIn()],
        component: ShellComponent,
        children: [
            {
                path: 'assessor',
                canActivate: [hasPermissionGuard('workspace.assessor')],
                loadChildren: () => import('./assessor/assessor.routing').then(({ routes }) => routes),
            },
            {
                path: 'organisation',
                canActivate: [hasPermissionGuard('workspace.organisation')],
                loadChildren: () => import('./organisation/organisation.routing').then(({ routes }) => routes),
            },
            {
                path: '',
                canActivate: [hasPermissionGuard('workspace.default')],
                providers: [
                    ...videosStoreProviders,
                    ...audioStoreProviders,
                    ...materialsStoreProviders,
                    ...imageBlockStoreProviders,
                    ...textStoreProviders,
                    ...newsStoreProviders,
                    ...profileStatisticsStoreProviders,
                    ...certificatesStoreProviders,
                    ...learningPortfolioStoreProviders,
                ],
                children: [
                    ...menuAdminRoutes,
                    ...modalRoutes,
                    {
                        path: 'temp',
                        loadChildren: () => import('./temp/temp.routing').then(({ routes }) => routes),
                    },
                    {
                        path: 'admin',
                        canActivate: [hasPermissionGuard('admin.access')],
                        loadChildren: () => import('./admin/admin.routing').then(({ routes }) => routes),
                    },
                    {
                        path: 'dashboard',
                        loadChildren: () => import('./dashboard/dashboard.routing').then(({ routes }) => routes),
                    },
                    {
                        path: 'news',
                        loadChildren: () => import('./news/news.routing').then(({ routes }) => routes),
                    },
                    {
                        path: 'all-courses',
                        canActivate: [allCoursesEnabled()],
                        loadChildren: () => import('./all-courses/all-courses.routing').then(({ routes }) => routes),
                    },
                    {
                        path: 'library',
                        loadChildren: () => import('./library/library.routing').then(({ routes }) => routes),
                    },
                    {
                        path: 'learning-portfolio',
                        canActivate: [learningPortfolioEnabled()],
                        loadChildren: () => import('./learning-portfolio/learning-portfolio.routing').then(({ routes }) => routes),
                    },
                    {
                        path: 'packages',
                        canActivate: [packagesEnabled()],
                        loadChildren: () => import('./packages/packages.routing').then(({ routes }) => routes),
                    },
                    {
                        path: 'settings',
                        loadChildren: () => import('./settings/settings.routing').then(({ routes }) => routes),
                    },
                    {
                        path: 'profile',
                        loadChildren: () => import('./profile/profile.routing').then(({ routes }) => routes),
                    },
                    {
                        path: '**',
                        loadChildren: () => import('@error/not-found').then(({ routes }) => routes),
                    },
                ],
            },
        ],
    },
];
